import WOTemplate from './WOTemplates';

export default WOTemplate;
